import { createRouter, createWebHistory } from 'vue-router';
import { replaceByPath, getQueryString, removeQuery } from './utils/tools';
import store from './store';

const routes = [
  {
    name: '',
    path: '/',
    redirect: {
      name: 'index',
    },
  },
  {
    name: 'index',
    path: '/index',
    component: () => import(/* webpackChunkName: "Form" */ './view/Form'),
    meta: {
      title: '微信表单'
    },
  },
  {
    name: 'success',
    path: '/success',
    component: () => import(/* webpackChunkName: "Success" */ './view/Success'),
    meta: {
      title: ''
    },
  },
  {
    name: 'nopermit',
    path: '/nopermit',
    component: () => import(/* webpackChunkName: "NoPermit" */ './view/NoPermit'),
    meta: {
      title: '暂未开放'
    },
  },
  {
    name: 'noweixin',
    path: '/noweixin',
    component: () => import(/* webpackChunkName: "NoWeixin" */ './view/NoWeixin'),
    meta: {
      title: '微信扫码继续填写'
    },
  }
];

const base = process.env.NODE_ENV === "development" ? '' : '/addon/app-commonapply'; // 设置线上页面路径
const router = createRouter({
  routes,
  history: createWebHistory(base)
});

router.beforeEach(async (to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  const queryToken = getQueryString('token');
  if (queryToken) {
    store.commit('SET_TOKEN', queryToken);
    let path = to.path;
    const searchQuery = removeQuery(window.location.search.substr(1), 'token');
    path = searchQuery ? `${path}?${searchQuery}` : path;
    replaceByPath(path);
  } else {
    next();
  }
});

export { router };